export function isValidPhone(str: string) {
  return /^\(\d{2}\) 9?\d{4}[- ]\d{4}$/.test(str);
}